import React from "react";

import axios from "axios";
import { Input, Button, Card, DatePicker, Spin } from "antd";
import moment from "moment";

export default class RelatorioSMSHot extends React.Component {
  state = {
    filtro: "",
    inicio: "",
    fim: "",
    visible: false
  };

  onChangeInput = value => {
    this.setState({
      ...this.state,
      filtro: document.getElementById("filtro").value
    });
  };

  onChangeDate = dates => {
    this.setState({
      ...this.state,
      inicio: dates[0].format("YYYY-MM-DD"),
      fim: dates[1].format("YYYY-MM-DD")
    });
  };

  handleClick = async () => {
    if (this.state.filtro === "") {
      window.alert("Falta preencher o id do filtro");
      return;
    } else if (this.state.inicio === "") {
      window.alert("Falta preencher a data de inicio");
      return;
    } else if (this.state.fim === "") {
      window.alert("Falta preencher a data de fim");
      return;
    }
    this.setState({
      ...this.state,
      visible: true
    });
    const payload = {
      inicio: this.state.inicio,
      fim: this.state.fim,
      filtro: this.state.filtro
    };
    const resp = await axios.post(
      process.env.REACT_APP_API_REPORT_SMS,
      payload
    );
    if (resp.status === 200) {
      window.open(resp.data);
    } else {
      window.alert("Ocorreu um erro");
    }
    this.setState({
      ...this.state,
      visible: false
    });
  };

  render() {
    console.log(this.state);
    if (this.state.visible === true) {
      return (
        <React.Fragment>
          <div style={{ width: "50%", marginLeft: "50%", marginTop: "50px" }}>
            <Spin></Spin>
          </div>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <Card title="Relatório de SMS">
          <div style={{ width: "40%", marginLeft: "30%", padding: "20px" }}>
            Filtro:{" "}
            <Input
              id="filtro"
              onChange={e => this.onChangeInput(e)}
              placeholder="ID do filtro do pipedrive"
            ></Input>
            <br />
            <br />
            Período:{" "}
            <DatePicker.RangePicker
              format="YYYY-MM-DD"
              onChange={this.onChangeDate}
            />
            <br />
            <br />
            <Button type="primary" onClick={this.handleClick}>
              Gerar
            </Button>
          </div>
        </Card>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Relatorios/RelatorioSMS/RelatorioSMS.js